import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	presentationId: '',
	presentationUid: '',
	appUid: '',
}

function createInitializeSuccess(state, action) {
	return {
		...state,
		presentationId: action.presentationId,
		presentationUid: action.presentationUid,
		appUid: action.appUid,
	}
}

function finalize() {
	return {
		...defaultState,
	}
}

const collaborateReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_SUCCESS:
			return createInitializeSuccess(state, action)
		case actionTypes.QUICK_LAUNCH_COLLABORATE_FINALIZE_CREATION_TOOL:
			return finalize()
		default: return state
	}
}

export default collaborateReducer
